import { render, staticRenderFns } from "./VeDienTuList.vue?vue&type=template&id=473f455f"
import script from "./VeDienTuList.vue?vue&type=script&lang=js"
export * from "./VeDienTuList.vue?vue&type=script&lang=js"
import style0 from "./VeDienTuList.vue?vue&type=style&index=0&id=473f455f&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports